<form [formGroup]="jobManagementForm">
  <div class="modal-header">
    <h1>{{title}}</h1>
  </div>
  <div class="modal-body">
    <div class="alert alert-danger alert-dismissable" *ngIf="errorMsg">
      {{errorMsg}}
      <a (click)="clearErrorMessage()">
        <span class="float-right close-button">
          <fa-icon [icon]="faTimes"></fa-icon>
        </span>
      </a>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label>Name</label>
          <input type="text" class="form-control" formControlName="name" [appTrim]="!jobManagement">
          <div class="mt-sm" [hidden]="jobManagementForm.controls['name'].valid">
            <small class="text-danger">Input name</small>
          </div>
        </div>
      </div>
      <div class="col-sm-12">
        <div class="form-group">
          <label>Class Name</label>
          <input type="text" class="form-control" formControlName="className" [appTrim]="!jobManagement">
          <div class="mt-sm" [hidden]="jobManagementForm.controls['className'].valid">
            <small class="text-danger">Input class name</small>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label>Status</label>
          <select formControlName="status" class="form-control">
            <option *ngFor="let option of statuses" value="{{option}}">{{option}}</option>
          </select>
          <div class="mt-sm" [hidden]="jobManagementForm.controls['status'].valid">
            <small class="text-danger">Select status</small>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="form-group">
          <label>Description</label>
          <textarea formControlName="description" class="form-control vertical-expand" [appTrim]="!jobManagement"></textarea>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-6">
        <div class="checkbox checkbox-success">
          <input id="enabled" formControlName="enabled" type="checkbox" class="mr-2">
          <label for="enabled">
            Enabled
          </label>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-dark-blue" type="submit" [disabled]="!jobManagementForm.valid" (click)="ok()" title="Save"><fa-icon [icon]="faSave"></fa-icon></button>
    <button class="btn btn-attention" type="button" (click)="cancel()" title="Cancel"><fa-icon [icon]="faTimes"></fa-icon></button>
  </div>
</form>